import React, { Fragment, useState } from 'react'
import {
  Box,
  Typography,
  IconButton
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded'
import fileIcon from '../../assets/icons/file.svg'
import { leftPanelStyles } from '../../styles/classes/FormBuilderClasses'
import { useTranslation } from 'react-i18next'
import SectionListItem from './SectionListItem'
import { cloneDeep, getFirstKeyFromObject } from '../../utils/formBuilder'
import { useSelector } from 'react-redux'

const StructureTab = ({
  onAddSection,
  configurationsField,
  onEditSectionName,
  onRemoveSection,
  allDisabled
}) => {
  const panelsQuery = useSelector(state => state.loading.panelsQuery)

  const { classes } = leftPanelStyles()
  const [showStructureSection, setShowStructureSection] = useState(true)
  const { t } = useTranslation()

  // todo handle multiple pages
  const sections = configurationsField[0]?.page_questions ?? []

  const showStructureSectionHandler = () => {
    setShowStructureSection(prevState => !prevState)
  }

  let filteredData = cloneDeep(sections)
  if (panelsQuery?.length > 0) {
    const lowerCaseQuery = panelsQuery.toLowerCase()
    const tmp = []
    filteredData.forEach(section => {
      const sectionKey = getFirstKeyFromObject(section)
      section[sectionKey].questions = section[sectionKey].questions.filter(
        item => {
          // search inside type translated
          const keyTextTranslated = t(
            `form_builder.elements.${item[getFirstKeyFromObject(item)].type}`
          )
          const elementTitle = item[getFirstKeyFromObject(item)].title
          return (
            keyTextTranslated.toLowerCase().includes(lowerCaseQuery) ||
            elementTitle.toLowerCase().includes(lowerCaseQuery)
          )
        }
      )
      if (section[sectionKey].questions.length > 0) {
        tmp.push(section)
      }
    })
    filteredData = tmp
  }

  const sectionsComponent = () => {
    return (
      <Fragment>
        <Box className={classes.headerContainer}>
          <Typography className={classes.sectionsTitle}>
            {t('form_builder.left_panel.sections')}
          </Typography>
          <IconButton
            disabled={allDisabled}
            onClick={onAddSection}
            size="small"
            className={classes.iconButton}
          >
            <AddIcon className={classes.addIcon} />
          </IconButton>
        </Box>
        {filteredData.map((section, idx) => {
          const sectionKey = getFirstKeyFromObject(section)
          const sectionTitle = section[sectionKey]?.title
          const trashable = sections.length > 1
          return (
            <SectionListItem
              allDisabled={allDisabled}
              trashable={trashable}
              key={sectionKey}
              sectionTitle={sectionTitle}
              onSectionTitleChange={onEditSectionName}
              sectionIndex={idx}
              pageIndex={0}
              onRemoveSection={onRemoveSection}
            />
          )
        })}
      </Fragment>
    )
  }

  return (
    <Box className={classes.structureTab}>
      <Box className={classes.pagesTitle}>
        <Typography className={classes.panelPagesTitle}>
          {t('form_builder.left_panel.pages')}
        </Typography>
        <AddIcon className={classes.pagesAddIcon} />
      </Box>
      <Box className={classes.pagesListContainer}>
        <Box className={classes.pageCounterContainer}>
          <Box display="flex" alignItems="center">
            <Box className={classes.pageIcon}>
              <img src={fileIcon} alt="lock icon" />
            </Box>
            <Typography className={classes.pageCounter}>Page 1</Typography>
          </Box>
          <IconButton
            onClick={showStructureSectionHandler}
            color="inherit"
            size="small"
            disableRipple
            className={classes.arrowIconButton}
          >
            {showStructureSection && <ArrowDropDownRoundedIcon />}
            {!showStructureSection && <ArrowLeftRoundedIcon />}
          </IconButton>
        </Box>
        {showStructureSection && sectionsComponent()}
      </Box>
    </Box>
  )
}

export default StructureTab
